import api from './api';
import { invalidarCachePrograma } from './programaService';

export const obtenerConfigCalidad = async () => {
  const res = await api.get('/programa/calidad-config');
  return res.data.actividadesCalidad || [];
};

export const guardarConfigCalidad = async (actividadesCalidad) => {
  const res = await api.put('/programa/calidad-config', { actividadesCalidad });
  return res.data.actividadesCalidad;
};

export const actualizarAvanceCalidad = async (programaId, actividadId, cambios) => {
  const res = await api.put(`/programa/${programaId}/actividades/${actividadId}`, cambios);
  invalidarCachePrograma();
  return res.data.actividad;
};

export const obtenerConfigRegistroCalidad = async () => {
  const res = await api.get('/programa/registro-calidad-config');
  return res.data.actividadesRegistroCalidad || [];
};

export const guardarConfigRegistroCalidad = async (actividadesRegistroCalidad) => {
  const res = await api.put('/programa/registro-calidad-config', { actividadesRegistroCalidad });
  return res.data.actividadesRegistroCalidad;
};
